export const OPEN_CONNECT_MODAL = "OPEN_CONNECT_MODAL"
export const CLOSE_CONNECT_MODAL = "CLOSE_CONNECT_MODAL"


export const CONNECT_USER = "CONNECT_USER"
export const CONNECT_USER_SUCCESS = "CONNECT_USER_SUCCESS"
export const CONNECT_USER_FAILURE = "CONNECT_USER_FAILURE"

export const DISCONNECT_USER = "DISCONNECT_USER"
export const DISCONNECT_USER_SUCCESS = "DISCONNECT_USER_SUCCESS"
export const DISCONNECT_USER_FAILURE = "DISCONNECT_USER_FAILURE"


export const FETCH_USER = "FETCH_USER"
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS"
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE"

export const LIKE_REQUEST = "LIKE_REQUEST"
export const LIKE_REQUEST_SUCCESS = "LIKE_REQUEST_SUCCESS"
export const LIKE_REQUEST_FAILURE = "LIKE_REQUEST_FAILURE "

export const LIKE_NFT = "LIKE_NFT"
export const LIKE_NFT_SUCCESS = "LIKE_NFT_SUCCESS"
export const LIKE_NFT_FAILURE = "LIKE_NFT_FAILURE "

export const DISLIKE_NFT = "DISLIKE_NFT"
export const DISLIKE_NFT_SUCCESS = "DISLIKE_NFT_SUCCESS"
export const DISLIKE_NFT_FAILURE = "DISLIKE_NFT_FAILURE "